var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.9 43.3l2.7-9.8C5.9 30.6 5 27.3 5 24 5 13.5 13.5 5 24 5c5.1 0 9.8 2 13.4 5.6C41 14.2 43 18.9 43 24c0 10.5-8.5 19-19 19-3.2 0-6.3-.8-9.1-2.3l-10 2.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.9 43.8c-.1 0-.3-.1-.4-.1-.1-.1-.2-.3-.1-.5L7 33.5c-1.6-2.9-2.5-6.2-2.5-9.6C4.5 13.2 13.3 4.5 24 4.5c5.2 0 10.1 2 13.8 5.7 3.7 3.7 5.7 8.6 5.7 13.8 0 10.7-8.7 19.5-19.5 19.5-3.2 0-6.3-.8-9.1-2.3L5 43.8h-.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M24 5c5.1 0 9.8 2 13.4 5.6C41 14.2 43 18.9 43 24c0 10.5-8.5 19-19 19-3.2 0-6.3-.8-9.1-2.3l-10 2.6 2.7-9.8C5.9 30.6 5 27.3 5 24 5 13.5 13.5 5 24 5m0-1C13 4 4 13 4 24c0 3.4.8 6.7 2.5 9.6L3.9 43c-.1.3 0 .7.3 1 .2.2.4.3.7.3h.3l9.7-2.5c2.8 1.5 6 2.2 9.2 2.2 11 0 20-9 20-20 0-5.3-2.1-10.4-5.8-14.1C34.4 6.1 29.4 4 24 4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#40c351",
    d: "M35.2 12.8c-3-3-6.9-4.6-11.2-4.6-8.7 0-15.8 7.1-15.8 15.8 0 3 .8 5.9 2.4 8.4l.4.6-1.6 5.8 6-1.6.6.3c2.4 1.4 5.2 2.2 8 2.2 8.7 0 15.8-7.1 15.8-15.8 0-4.1-1.6-8.1-4.6-11.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.3 16c-.4-.8-.7-.8-1.1-.8h-.9c-.3 0-.8.1-1.3.6-.4.5-1.7 1.6-1.7 4s1.7 4.6 1.9 4.9 3.3 5.3 8.1 7.2c4 1.6 4.8 1.3 5.7 1.2.9-.1 2.8-1.1 3.2-2.3.4-1.1.4-2.1.3-2.3-.1-.2-.4-.3-.9-.6s-2.8-1.4-3.2-1.5c-.4-.2-.8-.2-1.1.2-.3.5-1.2 1.5-1.5 1.9-.3.3-.6.4-1 .1-.5-.2-2-.7-3.8-2.4-1.4-1.3-2.4-2.8-2.6-3.3-.3-.5 0-.7.2-1 .2-.2.5-.6.7-.8.2-.3.3-.5.5-.8.2-.3.1-.6 0-.8-.2-.2-1.1-2.5-1.5-3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp48);
export default __webpack_public_path__ + "static/media/whatsapp-48.52da092f093c1d11c1089bdf7738e093.svg";
export { ForwardRef as ReactComponent };